import { render, staticRenderFns } from "./BonusCardLoading.vue?vue&type=template&id=21a38e32"
import script from "./BonusCardLoading.vue?vue&type=script&lang=js"
export * from "./BonusCardLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsSkeletonLoader: require('/app/components/Commons/SkeletonLoader.vue').default})
